// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_2XdCorMnT_","item":"Bvr6-QGVUm","link":"_2oBhIn80AK","item-navigation-next":"_2RjefUE7_A","itemNavigationNext":"_2RjefUE7_A","item-navigation-prev":"_1_dn5-7LG_","itemNavigationPrev":"_1_dn5-7LG_","item-disabled":"_2nMUdGHh94","itemDisabled":"_2nMUdGHh94","item-active":"rZqPAn3mlB","itemActive":"rZqPAn3mlB","item-break":"_2OpiXvHa4M","itemBreak":"_2OpiXvHa4M"};
    if(module.hot) {
      // 1597843263582
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  